import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Printer, Mail, ArrowLeft } from "lucide-react";
import { api } from "../lib/api";

export default function ClubGiftCard() {
  const { token } = useParams();
  const [card, setCard] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/mailclub/gift-card/${encodeURIComponent(token)}`).then(r => setCard(r.data))
      .catch(e => setErr(e.response?.data?.detail || "Carte introuvable"));
  }, [token]);

  if (err) return <div data-testid="club-gift-card-error" className="max-w-xl mx-auto px-6 py-24 text-center"><p className="font-serif text-2xl mb-4">Carte introuvable</p><p className="text-[#7C7064] text-sm">{err}</p><Link to="/club-de-lettres" className="btn-outline mt-8 inline-flex">Retour au Club de Lettres</Link></div>;
  if (!card) return <p className="text-center py-24 text-[#7C7064]">Chargement…</p>;

  return (
    <div data-testid="club-gift-card-page" className="paper-grain bg-[#F5F0E6] min-h-screen py-10 md:py-16 print:bg-white print:py-0">
      <div className="max-w-3xl mx-auto px-6 print:hidden flex flex-wrap items-center justify-between gap-3 mb-8">
        <Link to="/club-de-lettres" className="inline-flex items-center gap-1 text-sm text-[#7C7064] hover:text-[#C35A3E]"><ArrowLeft size={14}/> Le Club de Lettres</Link>
        <button data-testid="club-gift-card-print" onClick={() => window.print()} className="inline-flex items-center gap-2 px-6 py-3 bg-[#C35A3E] text-[#FDFBF7] hover:bg-[#A94A31] transition-colors"><Printer size={16}/> Imprimer la carte</button>
      </div>

      <div data-testid="club-gift-card" className="max-w-3xl mx-auto bg-[#FDFBF7] border border-[#E8DCC8] shadow-[0_24px_60px_-30px_rgba(44,38,33,.5)] print:shadow-none print:border-0 relative overflow-hidden">
        <div className="absolute inset-3 border border-dashed border-[#D9C9B3] pointer-events-none"/>
        <div className="px-8 md:px-16 py-12 md:py-16 text-center relative">
          <div className="wax-seal mx-auto mb-6"><Mail size={20}/></div>
          <p className="font-script text-5xl md:text-6xl text-[#C35A3E] leading-none mb-3">Le Club de Lettres</p>
          <p className="text-xs uppercase tracking-[.25em] text-[#7C7064] mb-10">Carte cadeau · Les RDV de l'écriture</p>

          <p className="font-serif text-2xl md:text-3xl text-[#2C2621] leading-snug mb-6">
            Pour <span className="italic text-[#A3876A]">{card.recipient_first_name}</span>,<br/>
            {card.months} mois d'enveloppes à ouvrir lentement.
          </p>
          <p className="text-[#4A4036] leading-relaxed max-w-lg mx-auto mb-8">
            Chaque mois, autour du 10, une enveloppe arrive dans ta boîte aux lettres : une lettre écrite à la main, une inspiration de la nature, une carte à garder, une invitation à écrire à ton tour et une petite attention.
            {card.first_month && <> Ta première enveloppe sera celle de <strong>{card.first_month}</strong>{card.last_month && card.last_month !== card.first_month ? <>, la dernière celle de <strong>{card.last_month}</strong></> : null}.</>}
          </p>

          {card.dedication && (
            <div className="sticker sticker-cream -rotate-1 mx-auto max-w-md text-left mb-8 !block px-6 py-4">
              <p className="font-hand text-2xl text-[#2C2621] leading-snug whitespace-pre-line">« {card.dedication} »</p>
            </div>
          )}

          <p className="font-hand text-2xl text-[#C35A3E]">Offert avec tendresse par {card.buyer_name}</p>
          <p className="text-xs text-[#7C7064] mt-8">Rien à faire de ton côté : l'adresse est déjà enregistrée. Pour en savoir plus : lesrdvdelecriture.com/club-de-lettres</p>
        </div>
      </div>
    </div>
  );
}
